import React from 'react';
import { observer } from 'mobx-react-lite';
import { CssBaseline, AppBar, Toolbar, Typography, Container, Box, Button, Stack } from '@mui/material';
import { HashRouter, Routes, Route, Link, Navigate, useNavigate } from 'react-router-dom';
import store from './store';
import Login from './pages/Login';
import EmployeeApply from './pages/EmployeeApply';
import AdminReview from './pages/AdminReview';
import AdminDashboard from './pages/AdminDashboard';

const NavBar = observer(() => {
  const navigate = useNavigate();
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          报销系统
        </Typography>
        {store.currentUser ? (
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body2">{store.currentUser.username}</Typography>
            <Button color="inherit" onClick={() => { store.logout(); navigate('/login'); }}>退出</Button>
          </Stack>
        ) : (
          <Button color="inherit" component={Link} to="/login">登录</Button>
        )}
      </Toolbar>
    </AppBar>
  );
});

const RequireAuth = observer(({ children, role }) => {
  if (!store.currentUser) return <Navigate to="/login" replace />;
  if (role && store.currentUser.role !== role) return <Navigate to="/login" replace />;
  return children;
});

const App = observer(() => {
  return (
    <HashRouter>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/apply" element={
          <>
            <NavBar />
            <Container maxWidth="md">
              <Box sx={{ mt: 4 }}>
                <RequireAuth role="employee"><EmployeeApply /></RequireAuth>
              </Box>
            </Container>
          </>
        } />
        <Route path="/admin" element={
          <>
            <NavBar />
            <Container maxWidth="md">
              <Box sx={{ mt: 4 }}>
                <RequireAuth role="admin"><AdminDashboard /></RequireAuth>
              </Box>
            </Container>
          </>
        } />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </HashRouter>
  );
});

export default App;


